var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxChecked = function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#77A2B3",
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "#77A2B3",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFBF0",
    d: "M6.774 11.242a.55.55 0 0 1-.187-.032.436.436 0 0 1-.163-.106l-2.15-2.15a.463.463 0 0 1-.131-.356.504.504 0 0 1 .144-.356.474.474 0 0 1 .35-.138c.142 0 .258.046.35.138l1.787 1.787 4.238-4.237a.482.482 0 0 1 .356-.138c.146 0 .265.046.356.138.092.091.138.21.138.356a.482.482 0 0 1-.138.356l-4.6 4.6a.436.436 0 0 1-.162.106.55.55 0 0 1-.188.032"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFBF0",
    d: "M6.78 10.742h-.011L4.643 8.615a.136.136 0 0 1 0-.01l1.778 1.778.353.353.354-.353 4.228-4.228h.006a.4.4 0 0 1 0 .005L6.78 10.742ZM4.643 8.628Z"
  })));
};
export default SvgCheckboxChecked;